import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        store_nombre_empleado_a: '',
        store_nombre_empleado_b: '',
        store_codigo_plaza_a: '',
        store_codigo_plaza_b: ''
    },

    mutations: {
        // Mutaciones individuales
        SET_NOMBRE_EMPLEADO_A(state, valor) {
            state.store_nombre_empleado_a = valor;
        },
        SET_NOMBRE_EMPLEADO_B(state, valor) {
            state.store_nombre_empleado_b = valor;
        },
        SET_CODIGO_PLAZA_A(state, valor) {
            state.store_codigo_plaza_a = valor;
        },
        SET_CODIGO_PLAZA_B(state, valor) {
            state.store_codigo_plaza_b = valor;
        }
    },
    getters:{
        GET_NOMBRE_EMPLEADO_A: (state)=> state.store_nombre_empleado_a,
        GET_NOMBRE_EMPLEADO_B: (state)=> state.store_nombre_empleado_b,
        GET_CODIGO_PLAZA_A: (state)=> state.store_codigo_plaza_a,
        GET_CODIGO_PLAZA_B: (state)=> state.store_codigo_plaza_b,
    },
    actions: {
        // Acciones individuales
        updateNombreA({ commit }, valor) {
            console.log('aaaa');
            
            commit('SET_NOMBRE_EMPLEADO_A', valor);
        },
        updateNombreB({ commit }, valor) {
            commit('SET_NOMBRE_EMPLEADO_B', valor);
        },
        updatePlazaA({ commit }, valor) {
            commit('SET_CODIGO_PLAZA_A', valor);
        },
        updatePlazaB({ commit }, valor) {
            commit('SET_CODIGO_PLAZA_B', valor);
        }
    }
};